import { useAuthStore } from '../stores/authStore'

/**
 * Hook de leitura do estado de autenticação.
 * Pure selector — NÃO monta listener (isso é responsabilidade de `<AuthInit />`).
 */
export function useAuth() {
  const session = useAuthStore((s) => s.session)
  const profile = useAuthStore((s) => s.profile)
  const loading = useAuthStore((s) => s.loading)

  return {
    session,
    profile,
    loading,
    isAuthenticated: !!session && !!profile,
    isUnconfigured: !!session && !profile && !loading,
  }
}
